import { render, staticRenderFns } from "./AdminParticipantsTrigrammes.vue?vue&type=template&id=1c774512&"
import script from "./AdminParticipantsTrigrammes.vue?vue&type=script&lang=js&"
export * from "./AdminParticipantsTrigrammes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports